import React, { useState } from 'react';
import { Form, Input, Button, Checkbox, Row, Col, Card, Typography } from 'antd';
import { UserOutlined, MailOutlined, PhoneOutlined, HomeOutlined, IdcardOutlined, TagOutlined, FileTextOutlined, LockOutlined, CheckOutlined, SafetyCertificateOutlined, SolutionOutlined, ProfileOutlined, SaveOutlined } from '@ant-design/icons';

const { Text } = Typography;
const sectionCardStyle = {
  marginBottom: 28,
  borderRadius: 14,
  boxShadow: '0 4px 18px rgba(33, 71, 151, 0.09)',
  border: '1px solid #f0f2f5',
  // background: 'linear-gradient(135deg, #fafdff 0%,rgb(248, 247, 255) 100%)',
  paddingBottom: 8
};
const sectionTitleStyle = { fontWeight: 700, fontSize: '1.15rem', color: '#214797', display: 'flex', alignItems: 'center', margin: '10px 0' };
const sectionDescStyle = { color: '#6b7a99', fontSize: '0.77rem', marginBottom: 20 };

const ProfileForm = ({ form, handleFinish, btnLoading }) => {
  const [changePassword, setChangePassword] = useState(false);

  const toggleChangePassword = () => {
    setChangePassword(!changePassword);
  };

  return (
    <Form
      form={form}
      name="edit_profile_form"
      onFinish={handleFinish}
      layout="vertical"
      style={{ marginTop: 8 }}
    >
      <Card
        style={sectionCardStyle}
        title={<span style={sectionTitleStyle}><UserOutlined style={{ color: '#214797', marginRight: 10, fontSize: 20 }} />Personal Information</span>}
      >
        <div style={sectionDescStyle}>Update your personal details for your account.</div>
        <Row gutter={[16, 16]}>
          <Col xs={24} md={12}>
            <Form.Item
              name="name"
              label="First Name"
              rules={[{ required: true, message: 'Please enter your first name!' }]}
            >
              <Input placeholder="Enter your first name" prefix={<UserOutlined />} size="large" />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              name="last_name"
              label="Last Name"
              rules={[{ required: true, message: 'Please enter your last name!' }]}
            >
              <Input placeholder="Enter your last name" prefix={<UserOutlined />} size="large" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col xs={24} md={12}>
            <Form.Item
              name="email"
              label="Email"
              rules={[
                { required: true, message: 'Please enter your email!' },
                { type: 'email', message: 'Enter a valid email address!' },
              ]}
            >
              <Input placeholder="Enter your email" prefix={<MailOutlined />} size="large" />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              name="phone"
              label="Phone Number"
              rules={[
                { required: true, message: 'Please enter your phone number!' },
                {
                  message: 'Enter a valid phone number!',
                },
              ]}
            >
              <Input placeholder="Enter your phone number" prefix={<PhoneOutlined />} size="large" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Form.Item
              name="address"
              label="Address"
              rules={[{ required: true, message: 'Please enter your address!' }]}
            >
              <Input placeholder="Enter your address" prefix={<HomeOutlined />} size="large" />
            </Form.Item>
          </Col>
        </Row>
      </Card>
      <Card
        style={sectionCardStyle}
        title={<span style={sectionTitleStyle}><SolutionOutlined style={{ color: '#214797', marginRight: 10, fontSize: 20 }} />Company / Agency Information</span>}
      >
        <div style={sectionDescStyle}>Provide your agency or company details for business correspondence.</div>
        <Row gutter={[16, 16]}>
          <Col xs={24} md={12}>
            <Form.Item
              name="agency_name"
              label="Agency Name"
              rules={[{ required: true, message: 'Please enter your agency name!' }]}
            >
              <Input placeholder="Enter your agency name" prefix={<IdcardOutlined />} size="large" />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              name="license_number"
              label="License Number"
              rules={[{ required: true, message: 'Please enter your license number!' }]}
            >
              <Input placeholder="Enter your license number" prefix={<IdcardOutlined />} size="large" />
            </Form.Item>
          </Col>
        </Row>
      </Card>
      <Card
        style={sectionCardStyle}
        title={<span style={sectionTitleStyle}><ProfileOutlined style={{ color: '#214797', marginRight: 10, fontSize: 20 }} />Coversheet Section</span>}
      >
        <div style={sectionDescStyle}>Customize your coversheet tagline, products, and disclosure for your presentations.</div>
        <Row gutter={[16, 16]}>
          <Col xs={24} md={24}>
            <Form.Item
              name="coversheet_tagline"
              label="Coversheet Tagline"
              rules={[{ required: true, message: 'Please enter your coversheet tagline!' }]}
            >
              <Input placeholder="Enter your coversheet tagline" prefix={<TagOutlined />} size="large" />
            </Form.Item>
          </Col>
          <Col xs={24} md={24}>
            <Form.Item
              name="coversheet_products"
              label="Coversheet Products"
              rules={[{ required: true, message: 'Please enter your coversheet products!' }]}
            >
              <Input.TextArea rows={4} placeholder="Enter your coversheet products" prefix={<FileTextOutlined />} size="large" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Form.Item
              name="coversheet_disclosure"
              label="Coversheet Disclosure"
              rules={[{ required: true, message: 'Please enter your coversheet disclosure!' }]}
            >
              <Input.TextArea rows={4} placeholder="Enter your coversheet disclosure" prefix={<FileTextOutlined />} size="large" />
            </Form.Item>
          </Col>
        </Row>
      </Card>
      <Card
        style={sectionCardStyle}
        title={<span style={sectionTitleStyle}><SafetyCertificateOutlined style={{ color: '#214797', marginRight: 10, fontSize: 20 }} />Security</span>}
      >
        <div style={sectionDescStyle}>Change your password to keep your account secure.</div>
        <Form.Item>
          <Checkbox onChange={toggleChangePassword}>
            Change Password
          </Checkbox>
        </Form.Item>
        {changePassword && (
          <>
            <Form.Item
              name="password"
              label="New Password"
              rules={[
                { required: true, message: 'Please enter your new password!' },
                { min: 6, message: 'Password must be at least 6 characters!' },
              ]}
            >
              <Input.Password placeholder="Enter new password" prefix={<LockOutlined />} size="large" />
            </Form.Item>
            <Form.Item
              name="confirmPassword"
              label="Confirm Password"
              dependencies={['password']}
              rules={[
                { required: true, message: 'Please confirm your new password!' },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue('password') === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error('The passwords do not match!')
                    );
                  },
                }),
              ]}
            >
              <Input.Password placeholder="Confirm new password" prefix={<CheckOutlined />} size="large" />
            </Form.Item>
          </>
        )}
      </Card>
      <Form.Item style={{ marginTop: 32 }}>
        <Button type="primary" htmlType="submit" className="edit-profile-button" loading={btnLoading} block size="large" icon={<SaveOutlined />}>
          Save Changes
        </Button>
      </Form.Item>
    </Form>
  );
};

export default ProfileForm;
